import HakajimaiLanding from './pages/HakajimaiLanding';

function App() {
  return <HakajimaiLanding />;
}

export default App;
